<template>
  <div>
    <MainPage v-if="loaded" :shuffle-articles="true"> </MainPage>
  </div>
</template>

<script>
import MainPage from "./main.page";

export default {
  name: "GTAPage",
  components: { MainPage },
  data() {
    return {
      loaded: false
    };
  },
  mounted() {
    this.setPageContext("gta", () => {
      this.loaded = true;
    });
  }
};
</script>

<style scoped lang="scss"></style>
